export default "__VITE_ASSET__b70f5721__"